<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs4>
        <v-subheader>Email</v-subheader>
      </v-flex>
      <v-flex xs8>
        <v-text-field
          v-model="email"
          id="email"
          name="email"
          label="Email"
          class="input-group--focused"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs4>
        <v-subheader>Password</v-subheader>
      </v-flex>
      <v-flex xs8>
        <v-text-field
          v-model="password"
          :append-icon="e1 ? 'visibility' : 'visibility_off'"
          @click:append="() => (e1 = !e1)"
          :type="e1 ? 'password' : 'text'"
          name="input-10-1"
          label="Enter your password"
          hint="At least 8 characters"
          min="8"
          counter
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout align-end justify-end>
      <v-btn color="primary" v-on:click="signIn">Sign-in</v-btn>
    </v-layout>
  </v-container>
</template>

<script>


import Firebase from 'firebase/app'
import 'firebase/auth'

import { mapActions } from "vuex";

export default {
  data: function() {
    return {
      email: "",
      password: "",
      e1: true
    };
  },
  methods: {
    ...mapActions("authentication", {
      setUser: "setUser"
    }),
    signIn: function() {
      Firebase.auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            this.$router.push(this.$route.query.redirect || "/");
            this.setUser();
          },
          error => {
            alert(error.message);
          }
        );
    }
  }
};
</script>

<style>
</style>
